"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/* eslint-disable valid-jsdoc */
/* eslint-disable guard-for-in */
/* eslint-disable no-empty */
/* eslint-disable no-empty-function */
/* eslint-disable no-unused-vars */
/* eslint-disable sort-imports */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionKind = void 0;
var ExtensionKind;
(function (ExtensionKind) {
    ExtensionKind[ExtensionKind["NONE"] = 0] = "NONE";
    ExtensionKind[ExtensionKind["SEMANTICTYPE"] = 1] = "SEMANTICTYPE";
    ExtensionKind[ExtensionKind["SEMANTICUNIT"] = 2] = "SEMANTICUNIT";
    ExtensionKind[ExtensionKind["UNIT"] = 3] = "UNIT";
    ExtensionKind[ExtensionKind["UNITATTRIBUTE"] = 4] = "UNITATTRIBUTE";
    ExtensionKind[ExtensionKind["ADJUNCTTYPE"] = 5] = "ADJUNCTTYPE";
    ExtensionKind[ExtensionKind["LATENTTYPE"] = 6] = "LATENTTYPE";
    ExtensionKind[ExtensionKind["NAMEDLATENTTYPE"] = 7] = "NAMEDLATENTTYPE";
})(ExtensionKind = exports.ExtensionKind || (exports.ExtensionKind = {}));
//# sourceMappingURL=extensionKind.js.map